module.exports = __webpack_public_path__ + "media/images/connect-3e422061254d806eed6d99a445648579.png";